"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var material_1 = require("@angular/material");
var operators_1 = require("rxjs/operators");
var Subject_1 = require("rxjs/Subject");
var ejustice_notification_service_1 = require("../../../notification/service/api/ejustice-notification.service");
var document_operations_service_1 = require("../../../../shared/services/api/document-operations.service");
var recipients_list_provider_1 = require("../service/api/recipients-list-provider");
var zip_1 = require("rxjs/observable/zip");
var idm_de_service_client_js_1 = require("@synisys/idm-de-service-client-js");
var icon_info_provider_service_1 = require("../../../../shared/services/impl/icon-info-provider.service");
var NotificationDialogComponent = /** @class */ (function () {
    function NotificationDialogComponent(dialogData, dialogRef, deService, eJusticeNotificationService, documentOperationsService, recipientsListProvider) {
        this.dialogRef = dialogRef;
        this.deService = deService;
        this.eJusticeNotificationService = eJusticeNotificationService;
        this.documentOperationsService = documentOperationsService;
        this.recipientsListProvider = recipientsListProvider;
        this.destroy$ = new Subject_1.Subject();
        this.attachmentsTableColumns = ['title', 'size', 'remove'];
        this.dataSource = null;
        this.iconsInfo = {};
        this.notificationDto = new NotificationDto();
        this.isSendAsAttachment = false;
        this.recipientSources = [];
        this.recipientByType = {};
        this.constructNotificationDto(dialogData);
        this.rootEntityId = dialogData.rootEntityId;
        this.rootCategoryId = dialogData.rootCategoryId;
    }
    NotificationDialogComponent_1 = NotificationDialogComponent;
    NotificationDialogComponent.getConfig = function (rootEntityId, rootCategoryId, documents, savedDialogData) {
        var dialogConfig = new material_1.MatDialogConfig();
        dialogConfig.width = '820px';
        dialogConfig.height = 'auto';
        dialogConfig.autoFocus = false;
        dialogConfig.data = {
            rootEntityId: rootEntityId,
            rootCategoryId: rootCategoryId,
            documents: documents,
            savedDialogData: savedDialogData
        };
        return dialogConfig;
    };
    NotificationDialogComponent.prototype.ngOnInit = function () {
        this.initIconsInfo();
        this.initAttachmentConfig();
        this.initRecipients();
        this.dataSource = new material_1.MatTableDataSource(this.notificationDto.documents);
    };
    NotificationDialogComponent.prototype.ngOnDestroy = function () {
        this.destroy$.next();
        this.destroy$.complete();
    };
    NotificationDialogComponent.prototype.initIconsInfo = function () {
        for (var _i = 0, _a = this.notificationDto.documents; _i < _a.length; _i++) {
            var document_1 = _a[_i];
            var extension = document_1.docInfo['fileName'].substring(document_1.docInfo['fileName'].lastIndexOf('.'));
            this.iconsInfo[document_1.documentId] = icon_info_provider_service_1.IconInfoProviderService.getFileIconInfo(extension);
        }
    };
    NotificationDialogComponent.prototype.initAttachmentConfig = function () {
        var _this = this;
        this.eJusticeNotificationService.getAttachmentConfig()
            .pipe(operators_1.takeUntil(this.destroy$), operators_1.take(1))
            .subscribe(function (attachmentConfig) {
            _this.attachmentConfig = attachmentConfig;
            var attachmentsTotalSizeInMB = attachmentConfig.attachmentsTotalSize / 1024 / 1024;
            _this.attachmentsErrorMessageParams = [
                Number.isInteger(attachmentsTotalSizeInMB) ? attachmentsTotalSizeInMB.toString() : attachmentsTotalSizeInMB.toFixed(2)
            ];
        });
    };
    NotificationDialogComponent.prototype.initRecipients = function () {
        var _this = this;
        var rootEntity$ = this.deService.loadEntityByInstanceId(this.rootCategoryId, this.rootEntityId, false);
        zip_1.zip(rootEntity$, this.recipientsListProvider.getSources(this.rootCategoryId))
            .pipe(operators_1.switchMap(function (_a) {
            var rootEntity = _a[0], sources = _a[1];
            _this.recipientSources = sources;
            var recipients$ = sources.map(function (source) {
                return _this.recipientsListProvider.loadRecipients(source.key, _this.rootCategoryId, _this.rootEntityId, rootEntity)
                    .pipe(operators_1.tap(function (recipients) {
                    _this.recipientByType[source.key] = recipients.filter(function (recipient) { return NotificationDialogComponent_1.SIMPLE_EMAIL_PATTERN.test(recipient.email); });
                }));
            });
            return zip_1.zip.apply(void 0, recipients$);
        }), operators_1.takeUntil(this.destroy$)).subscribe();
    };
    NotificationDialogComponent.prototype.constructNotificationDto = function (dialogData) {
        if (dialogData.savedDialogData) {
            this.notificationDto.body = dialogData.savedDialogData.notificationDto.body;
            this.notificationDto.subject = dialogData.savedDialogData.notificationDto.subject;
            this.notificationDto.recipients = dialogData.savedDialogData.notificationDto.recipients || {};
            this.notificationDto.otherRecipients = dialogData.savedDialogData.notificationDto.otherRecipients;
            this.isSendAsAttachment = dialogData.savedDialogData.isSendAsAttachment || false;
        }
        this.notificationDto.documents = dialogData.documents;
    };
    NotificationDialogComponent.prototype.selectAllParties = function (recipientKey) {
        this.notificationDto.recipients[recipientKey] = this.recipientByType[recipientKey].map(function (recipient) { return recipient.email; });
    };
    NotificationDialogComponent.prototype.downloadDocument = function (document) {
        var documentId = document['documentId'];
        var parentCategoryName = document['metadata']['parentMainCategory'];
        var categoryFieldName = document['metadata']['subEntityField'];
        var entityInstanceId = document['metadata']['parentInstanceId'];
        this.documentOperationsService.downloadDocument(documentId, parentCategoryName, entityInstanceId, categoryFieldName)
            .pipe(operators_1.takeUntil(this.destroy$), operators_1.take(1))
            .subscribe();
    };
    NotificationDialogComponent.prototype.remove = function (document) {
        var index = this.notificationDto.documents.findIndex(function (item) { return item.documentId === document.documentId; });
        this.notificationDto.documents.splice(index, 1);
        this.dataSource = new material_1.MatTableDataSource(this.notificationDto.documents);
    };
    NotificationDialogComponent.prototype.addDocuments = function () {
        this.dialogRef.close({ isSendAsAttachment: this.isSendAsAttachment, notificationDto: this.notificationDto });
    };
    NotificationDialogComponent.prototype.cancel = function () {
        this.dialogRef.close();
    };
    NotificationDialogComponent.prototype.send = function () {
        var _this = this;
        var emails = this.getOtherRecipientsAsArray();
        var canSend = this.validateBeforeSend(emails);
        if (canSend) {
            for (var _i = 0, _a = this.recipientSources; _i < _a.length; _i++) {
                var recipientSource = _a[_i];
                var recipients = this.notificationDto.recipients[recipientSource.key];
                if (recipients) {
                    emails = emails.concat(recipients);
                }
            }
            var documentsIds = this.notificationDto.documents.map(function (document) { return document.documentId; });
            this.eJusticeNotificationService.sendEmail(this.rootCategoryId, this.rootEntityId, emails, this.notificationDto.subject, this.notificationDto.body, documentsIds, this.isSendAsAttachment).subscribe(function () { return _this.cancel(); });
        }
    };
    NotificationDialogComponent.prototype.getOtherRecipientsAsArray = function () {
        if (!this.notificationDto.otherRecipients) {
            return [];
        }
        return this.notificationDto.otherRecipients.split(';').map(function (email) { return email.trim(); }).filter(function (email) { return email !== ''; });
    };
    NotificationDialogComponent.prototype.validateBeforeSend = function (otherRecipients) {
        var canSend = true;
        if (this.notificationDto.subject == null || this.notificationDto.subject.trim() === '') {
            this.subjectErrorMessageKey = 'ejustice_field_is_required';
            canSend = false;
        }
        else {
            this.subjectErrorMessageKey = '';
        }
        if (otherRecipients.length === 0 && !this.isRecipientSelected()) {
            this.otherRecipientsErrorMessageKey = 'ejustice_notification_recipient_required';
            canSend = false;
        }
        else if (this.isEmailsInvalid(otherRecipients)) {
            this.otherRecipientsErrorMessageKey = 'ejustice_invalid_email_format';
            canSend = false;
        }
        else {
            this.otherRecipientsErrorMessageKey = '';
        }
        var isDocumentsSizeValid = this.isDocumentsSizeValid();
        if (isDocumentsSizeValid) {
            this.documentsSizeErrorMessageKey = '';
        }
        return canSend && isDocumentsSizeValid;
    };
    NotificationDialogComponent.prototype.isRecipientSelected = function () {
        var selectedRecipientsCount = 0;
        for (var _i = 0, _a = this.recipientSources; _i < _a.length; _i++) {
            var recipientSource = _a[_i];
            var recipients = this.notificationDto.recipients[recipientSource.key];
            selectedRecipientsCount += recipients ? recipients.length : 0;
        }
        return selectedRecipientsCount !== 0;
    };
    NotificationDialogComponent.prototype.isEmailsInvalid = function (emails) {
        return !emails.every(function (email) { return NotificationDialogComponent_1.SIMPLE_EMAIL_PATTERN.test(email); });
    };
    NotificationDialogComponent.prototype.isDocumentsSizeValid = function () {
        if (this.isSendAsAttachment) {
            var documentsSize = 0;
            for (var _i = 0, _a = this.notificationDto.documents; _i < _a.length; _i++) {
                var document_2 = _a[_i];
                documentsSize += document_2.docInfo['fileSize'];
                if (documentsSize > this.attachmentConfig.attachmentsTotalSize) {
                    this.documentsSizeErrorMessageKey = 'ejustice_notification_documents_size_error';
                    return false;
                }
            }
        }
        return true;
    };
    var NotificationDialogComponent_1;
    NotificationDialogComponent.SIMPLE_EMAIL_PATTERN = /^(.+)@(.{2,})(\.\w{2,})$/;
    NotificationDialogComponent = NotificationDialogComponent_1 = __decorate([
        core_1.Component({
            selector: 'ejustice-notification-dialog',
            template: require('./notification.dialog.component.html'),
            styles: [require('./notification.dialog.component.css')],
        }),
        __param(0, core_1.Inject(material_1.MAT_DIALOG_DATA)),
        __metadata("design:paramtypes", [Object, material_1.MatDialogRef,
            idm_de_service_client_js_1.DeService,
            ejustice_notification_service_1.EjusticeNotificationService,
            document_operations_service_1.DocumentOperationsService,
            recipients_list_provider_1.RecipientsListProvider])
    ], NotificationDialogComponent);
    return NotificationDialogComponent;
}());
exports.NotificationDialogComponent = NotificationDialogComponent;
var NotificationDto = /** @class */ (function () {
    function NotificationDto() {
        this.recipients = {};
        this.otherRecipients = '';
        this.subject = '';
        this.body = '';
        this.documents = [];
    }
    return NotificationDto;
}());
//# sourceMappingURL=notification.dialog.component.js.map